"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const CookieConsent_module_1 = tslib_1.__importDefault(require("./modules/CookieConsent.module"));
const loadCookieMessageModule = (initialData) => ({
    hasRouter: false,
    modules: [(0, CookieConsent_module_1.default)(initialData)],
});
exports.default = loadCookieMessageModule;
